<template>
    <div>
        <b-modal size="xl" :id="id" ref="finder" hide-footer :title="prefix + title">
            <TipoContratoList @close="tipoContratoSelect" :prefix="prefix + title + ' >'" />
        </b-modal>
        <lg-form-input-finder v-model="localValue" fieldDescription="descricao" :label="label"
            invalidFeedback="Tipo de Contrato deve ser informado!" description="" @handleClean="handleClear">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </div>
</template>

<script>
import TipoContratoList from "@/modules/cadastros/tipo-contrato/TipoContratoList.vue";
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";

export default {
    name: "LgFinderPageTipoContrato",
    components: { LgFormInputFinder, TipoContratoList },

    props: {
        id: {
            type: String,
            default: "finderTipoContrato",
        },
        value: Object,
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Tipo de Contrato",
        },
    },

    data() {
        return {
            localValue: this.value,
            title: "Tipo de Contrato",
        };
    },

    watch: {
        value(newValue) {
            this.localValue = newValue;
        },
        localValue(newValue) {
            this.$emit("input", newValue);
        },
    },

    methods: {
        async show() {
            await this.$refs.finder.show();
        },

        handleClear() {
            this.localValue = null;
            this.$emit("input", null);
            this.$refs.finder.hide();

        },

        tipoContratoSelect(item) {
            this.localValue = item;
            this.$refs.finder.hide();
            this.$emit("input", item);

        },
    },
};
</script>
